import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaBlock';
export function GuaranteeSection() {
  return <section className="bg-navy-950 py-14 text-white sm:py-20" aria-labelledby="guarantee-title" data-id="element-180" data-mp="1p341sdqiooa3">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-181" data-mp="1kaazdwiits16">
        <div className="rounded-3xl border border-clinic-500/40 bg-white/[0.04] p-5 text-center sm:p-8" data-id="element-182" data-mp="1fdap19en2349">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-clinic-500" data-id="element-183" data-mp="1ady3qt3f143s">
            <ShieldCheckIcon className="h-9 w-9 text-white" aria-hidden="true" data-id="element-184" data-mp="15djux8tzpq4p" />
          </span>
          <p className="mt-4 text-[11px] font-black uppercase tracking-[0.18em] text-clinic-300 sm:text-xs" data-id="element-185" data-mp="11e1byilqbp4i">
            Your purchase is completely protected
          </p>
          <h2 id="guarantee-title" className="mt-3 text-2xl font-black leading-tight tracking-tight sm:text-3xl" data-id="element-186" data-mp="2vqr5gz86qwbd">
            7-Day Money-Back Guarantee
          </h2>

          <p className="mt-5 text-[15px] font-semibold text-navy-100 sm:text-base" data-id="element-187" data-mp="1g4byc9jnowka">
            Try it. Review it. Explore the system. Use the educational resources in your clinical
            workflow.
          </p>
          <p className="mt-4 text-pretty text-[14.5px] leading-relaxed text-navy-200 sm:text-base" data-id="element-188" data-mp="1757074c0b58n">
            If, within the next seven days, you feel that the Clinical Decision System does not
            provide meaningful value to your clinical practice, contact us and request a refund.
          </p>
          <p className="mt-4 text-[14.5px] font-semibold text-white sm:text-base" data-id="element-189" data-mp="23td1bh9pzfi6">
            No complicated forms. No unnecessary back-and-forth.
            <br data-id="element-190" data-mp="1q16recx5u4r6" />
            You take the product. We take the risk.
          </p>
        </div>

        <CtaBlock tone="dark" kicker="Decide today with confidence." label="👉 I want to try it risk-free" data-id="element-191" data-mp="1uzrkzthwpq6n" />
      </div>
    </section>;
}